var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg005Shout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M497.807,232.355l-29.945,5.99v-88.276l29.945,5.99C506.06,157.709,512,164.954,512,173.37v41.673 C512,223.459,506.06,230.706,497.807,232.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M497.807,205.873l-29.945,5.99v26.483l29.945-5.99c8.253-1.651,14.193-8.896,14.193-17.312v-26.483 C512,196.977,506.06,204.222,497.807,205.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE4B50"
    },
    d: "M26.483,256h-8.828C7.904,256,0,248.096,0,238.345v-88.276c0-9.751,7.904-17.655,17.655-17.655h8.828 V256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M229.517,97.103V291.31c61.793,0,158.897,26.483,229.517,88.276V8.828 C388.414,70.621,291.31,97.103,229.517,97.103z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB3"
    },
    d: "M476.69,388.414h-8.828c-4.875,0-8.828-3.953-8.828-8.828V8.828c0-4.875,3.953-8.828,8.828-8.828 h8.828c4.875,0,8.828,3.953,8.828,8.828v370.759C485.517,384.461,481.565,388.414,476.69,388.414z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2555A"
    },
    d: "M242.05,494.345L242.05,494.345c-4.207,0-7.831-2.97-8.657-7.096L194.207,291.31H97.103 l39.88,199.401C139.459,503.09,150.328,512,162.952,512h79.098c4.875,0,8.828-3.953,8.828-8.828 C250.878,498.297,246.926,494.345,242.05,494.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE4B50"
    },
    d: "M211.862,291.31v10.177c0,4.316-3.119,7.998-7.377,8.707l-141.241,23.54 c-5.38,0.897-10.279-3.252-10.279-8.707V291.31H211.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M229.517,291.31H52.966c-19.501,0-35.31-15.809-35.31-35.31V132.414 c0-19.501,15.809-35.31,35.31-35.31h176.552V291.31z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.862,
    y: 97.103,
    style: {
      fill: "#959CB3"
    },
    width: 17.655,
    height: 194.207
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2555A"
    },
    d: "M17.655,229.517h194.207v61.793H52.966c-19.501,0-35.31-15.809-35.31-35.31V229.517z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.862,
    y: 229.517,
    style: {
      fill: "#707487"
    },
    width: 17.655,
    height: 61.793
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M229.517,291.31c61.793,0,158.897,26.483,229.517,88.276V273.655 c-70.621-29.426-167.724-44.138-229.517-44.138V291.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M476.69,282.483h-8.828c-4.875,0-8.828-3.953-8.828-8.828v105.931c0,4.875,3.953,8.828,8.828,8.828 h8.828c4.875,0,8.828-3.953,8.828-8.828V273.655C485.517,278.53,481.565,282.483,476.69,282.483z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg005Shout);
export default __webpack_public_path__ + "static/media/005-shout.f7b35c4c0f8e645976c4c1ee5f3761e7.svg";
export { ForwardRef as ReactComponent };